<script setup lang="ts">
    import { computed } from 'vue';
    import { useSearchContext } from '../composables/searchContext';
    import { parseFacetSelection } from '../utils/facetUtils';
    const props = defineProps<{ mobile?: boolean }>();
    const search = useSearchContext();
    const selectedFacets = computed(() => {
        const selected = parseFacetSelection(search.state.facetSelected);
        const productFacets = search.productFacets.value.flatMap((group) => group.Facet
            .filter((facet) => selected.get(group.AttributeTypeSk)?.has(facet.AttributeTypeValueSk))
            .map((facet) => ({ group: group.AttributeType, groupSk: group.AttributeTypeSk, value: facet.AttributeTypeValue, valueSk: facet.AttributeTypeValueSk })));
        const seriesFacets = search.seriesFacets.value.flatMap((series) => {
            const selectedChildren = series.SetFacet.filter((facet) => facet.IsSelected === 'Y');
            if (selectedChildren.length) {
                return selectedChildren.map((facet) => ({ group: series.SeriesName, groupSk: facet.AttributeTypeSk, value: `${facet.AttributeType}:${facet.SetProductCount}`, valueSk: facet.AttributeTypeValueSk }));
            }
            return selected.get(series.SeriesAttributeTypeSk)?.has(series.SeriesAttributeTypeValueSk)
                ? [{ group: 'Series', groupSk: series.SeriesAttributeTypeSk, value: series.SeriesName, valueSk: series.SeriesAttributeTypeValueSk }]
                : [];
        });
        return [...productFacets, ...seriesFacets];
    });
</script>

<template>
    <div class="refine-container">
        <div class="parentfacet-wholebody">
            <section v-if="search.hasFilters.value" :id="props.mobile ? 'divFiltersApplied' : 'divRefineApplied'" class="refine" aria-label="Applied filters">
                <h4 v-if="!props.mobile" id="refineTitle">Refine</h4><button type="button" class="cleartxt pill" @click="search.clearAll">Clear All</button>
                <span v-if="search.state.query" class="pill" :title="search.state.query">{{ search.state.query }} <button class="remove-filter fa-solid fa-xmark" type="button" aria-label="Clear search query" @click="search.clearQuery"></button></span>
                <span v-for="facet in selectedFacets" :key="`${facet.groupSk}-${facet.valueSk}`" class="pill" :title="facet.value">
                    {{ facet.value }}
                    <button class="remove-filter fa-solid fa-xmark" type="button" :aria-label="`Remove ${facet.value}`" @click="search.selectFacet(facet.groupSk, facet.valueSk)"></button>
                </span>
            </section>
        </div>
    </div>
</template>
